import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { Table } from 'components/FirstTimeExperienceModal/components/Table/Table'
import { PlatformIcon } from 'screens/ScheduledPosts/PlatformIcon'
import { InitiateOauthTrigger } from 'components/ConnectIntegrationTrigger/InitiateOauthTrigger'
import { Button } from 'blaze-ui/Button'
import { ArrowRight } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'

export const ProviderToName: Record<ExternalIntegrationEnum, string> = {
  [ExternalIntegrationEnum.Facebook]: 'Facebook',
  [ExternalIntegrationEnum.Instagram]: 'Instagram',
  [ExternalIntegrationEnum.LinkedIn]: 'LinkedIn',
  [ExternalIntegrationEnum.X]: 'X/Twitter',
  [ExternalIntegrationEnum.WordPress]: 'Wordpress',
  [ExternalIntegrationEnum.Google]: 'Google',
  [ExternalIntegrationEnum.GoogleDrive]: 'Google Drive',
  [ExternalIntegrationEnum.TikTok]: 'TikTok',
  [ExternalIntegrationEnum.YouTube]: 'Youtube',
  [ExternalIntegrationEnum.Mailchimp]: 'Mailchimp',
  [ExternalIntegrationEnum.MetaAds]: 'Meta Ads',
  [ExternalIntegrationEnum.GoHighLevel]: 'GoHighLevel',
  [ExternalIntegrationEnum.Wix]: 'Wix',
  [ExternalIntegrationEnum.Shopify]: 'Shopify',
}

export const ProviderToConnectText: Record<ExternalIntegrationEnum, string> = {
  [ExternalIntegrationEnum.Facebook]: 'Facebook Business',
  [ExternalIntegrationEnum.Instagram]: 'Instagram Business',
  [ExternalIntegrationEnum.LinkedIn]: 'LinkedIn Company Page',
  [ExternalIntegrationEnum.X]: 'X/Twitter',
  [ExternalIntegrationEnum.WordPress]: 'Wordpress',
  [ExternalIntegrationEnum.Google]: 'Google Analytics',
  [ExternalIntegrationEnum.GoogleDrive]: 'Google Drive',
  [ExternalIntegrationEnum.TikTok]: 'TikTok',
  [ExternalIntegrationEnum.YouTube]: 'Youtube',
  [ExternalIntegrationEnum.Mailchimp]: 'Mailchimp',
  [ExternalIntegrationEnum.MetaAds]: 'Meta Ads',
  [ExternalIntegrationEnum.GoHighLevel]: 'GoHighLevel',
  [ExternalIntegrationEnum.Wix]: 'Wix',
  [ExternalIntegrationEnum.Shopify]: 'Shopify',
}

export const ConnectIntegrationRow = ({ provider }: { provider: ExternalIntegrationEnum }) => (
  <Table.Row>
    <Table.Cell style={{ minWidth: '30%', alignItems: 'center', padding: '4px 0' }}>
      <PlatformIcon size={20} platform={provider} />
      <Text variant="smallList" lineClamp={1}>
        {ProviderToName[provider]}
      </Text>
    </Table.Cell>
    <Table.Cell style={{ minWidth: '67%', padding: '4px 0' }}>
      <InitiateOauthTrigger provider={provider}>
        <Button
          variant="ghost"
          size="md"
          endIcon={ArrowRight}
          aria-label={`Connect ${ProviderToConnectText[provider]}`}
        >
          Connect {ProviderToConnectText[provider]}
        </Button>
      </InitiateOauthTrigger>
    </Table.Cell>
  </Table.Row>
)
